var map = {
	"./scr1.jpg": 6216,
	"./scr10.jpg": 7778,
	"./scr2.jpg": 2711,
	"./scr3.jpg": 6906,
	"./scr4.jpg": 2649,
	"./scr5.jpg": 8300,
	"./scr6.jpg": 9819,
	"./scr7.jpg": 3982,
	"./scr8.jpg": 2637,
	"./scr9.jpg": 8064
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1914;